import React from 'react';
import SVG from 'react-inlinesvg';
import { Toast } from 'react-bootstrap';
import styled from 'styled-components';
import { SnackbarItem } from './context';
import infoSvg from 'assets/alerts/info.svg';
import xSvg from 'assets/icon/x.svg';
import { useTranslation } from 'react-i18next';

const ToastContainer = styled.div`
  position: absolute;
  max-width: 100vw;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding: 24px;
`;

const ToastStack = styled.div``;

const CustomToast = styled(Toast)`
  && {
    padding: 12px;
    border-radius: 8px;
    color: white;
    font-size: 1rem;
    flex-basis: auto;
    max-width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    background-color: ${(props) => props.theme.colors.malibu};

    &.error {
      background-color: ${(props) => props.theme.colors.radicalRed};
    }

    &.success {
      background-color: ${(props) => props.theme.colors.lightSeaGreen};
    }

    @media (min-width: 450px) {
      min-width: 400px;
    }

    .toast-info-icon {
      flex-shrink: 0;
    }

    path {
      fill: currentColor;
    }

    p {
      margin: 0 12px;
      width: 400px;
      flex-grow: 1;
    }

    button {
      border: none;
      background: none;
      color: inherit;
    }
  }
`;

interface Props {
  items: SnackbarItem[];
  onClose: (id: number) => void;
}

const SnackbarContainer = ({ items, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <ToastContainer>
      <ToastStack>
        {items.map((item: SnackbarItem) => (
          <CustomToast
            data-test-id="snackbar"
            key={item.id}
            className={`${item.isError ? 'error' : ''} ${item.isSuccess ? 'success' : ''}`}
            onClose={() => onClose(item.id)}
            show={true}
            delay={item.isError ? 12000 : 6000}
            autohide
          >
            <SVG src={infoSvg} className="toast-info-icon" />
            <p data-test-id="snackbar-text">
              {item.isError && <b>{t('error')}: </b>}
              {item.text}
            </p>
            <button data-test-id="snackbar-close-btn" onClick={() => onClose(item.id)}>
              <SVG src={xSvg} />
            </button>
          </CustomToast>
        ))}
      </ToastStack>
    </ToastContainer>
  );
};

export default SnackbarContainer;
